import { useToast } from "vue-toastification"
import store from "@/store"
import { getHomeInformations } from "@/services/intratone/home.js"
import { getUserRight } from "@/services/intratone/right.js"

const toast = useToast()

const mixins = {
    methods: {
        async connexion(authResponse) {
            try {
                if (
                    authResponse.status !== 200 ||
                    authResponse.data ===
                        "Impossible de se connecter ('.sql.intratone.info.') ! (Too many connections)"
                ) {
                    throw new Error("Cannot access intratone.info")
                }

                if (authResponse.data.error === 1) {
                    if (authResponse.data.message === "") {
                        throw new Error(this.$t("alerts.connection.failed"))
                    } else {
                        throw new Error(authResponse.data.message)
                    }
                }

                // Storing Prog Version
                localStorage.setItem(
                    "PROG_VERSION",
                    authResponse.data.PROG_VERSION,
                )

                storingUserData(authResponse)

                await userRight(this.$t)

                await accountInformation(this.$t)

                await initDataAndRedirectionHomePage.call(this, authResponse)

                // Alert : connected
                toast.success(
                    this.$t("alerts.connection.connected", {
                        name: store.getters["account/getFullName"],
                    }),
                    {
                        icon: "fas fa-power-off",
                    },
                )
            } catch (error) {
                this.disableLoginButton = false
                toast.error(error.message, {
                    icon: "fas fa-exclamation-circle",
                    timeout: 10000,
                })
            }
        },

        termsOfUsesModale(url) {
            this.openModal("terms-of-uses", {
                title: "termsOfUses.title",
                descriptionKey: "login.termsOfUses.message",
                SID: this.SID,
                connect: (arg) => {
                    this.connexion(arg)
                },
                refuse: () => {
                    this.$router.push({ name: "Login" })
                },
                url: url,
            })
        },
    },
}

function storingUserData(authResponse) {
    if (authResponse.data.session) {
        store.commit("auth/setJwtValues", {
            jwt: authResponse.data.session.jwt,
            expireAt: authResponse.data.session.jwt_expire,
            jwtRenew: authResponse.data.session.renew,
            renewExpireAt: authResponse.data.session.renew_expire,
        })

        localStorage.setItem("apiintra_jwt", authResponse.data.session.jwt)
        localStorage.setItem(
            "apiintra_jwt_expire",
            authResponse.data.session.jwt_expire,
        )
        localStorage.setItem(
            "apiintra_renew_expire",
            authResponse.data.session.renew_expire,
        )
        store.commit("auth/setLogged", true)
    }

    store.commit("account/setId", authResponse.id)
    if (authResponse.data.define) {
        store.commit("account/setDefine", authResponse.data.define)
        store.commit("account/setCountry", authResponse.data.define.country)
    }

    authResponse.data.ROBOT ? store.commit("account/setIpass", true) : null

    store.commit("auth/setLogged", true)

    // TEMP
    if (authResponse.data.SID) {
        store.commit("auth/setIntratoneDev2SID", authResponse.data.SID)
    }
}

async function userRight($t) {
    let userRightsResponse = await getUserRight()
    if (userRightsResponse === false || userRightsResponse.data.error) {
        throw new Error($t("alerts.connection.failed"))
    } else {
        const rightList = []
        userRightsResponse.data.rights &&
            userRightsResponse.data.rights.list.forEach((e) => {
                rightList.push(e.define)
            })
        store.commit("auth/setRights", rightList)

        const privilegesList = []
        userRightsResponse.data.privileges &&
            userRightsResponse.data.privileges.list.forEach((e) => {
                privilegesList.push(e.keyname)
            })
        store.commit("auth/setPrivileges", privilegesList)

        store.commit("account/setLogin", userRightsResponse.data.compte)

        store.commit(
            "account/setAdmin",
            rightList.length === 1 && rightList[0] === "ADMIN",
        )
    }
}

async function accountInformation($t) {
    const params = {
        user: +true,
        messages: "unread",
    }
    let homeResponse = await getHomeInformations(params)
    if (homeResponse === false) {
        throw new Error($t("alerts.connection.failed"))
    }

    // Storing global account informations
    store.commit("account/setFirstName", homeResponse.data.user.prenom)
    store.commit("account/setLastName", homeResponse.data.user.nom)
}

function initHomeToBreadCrumb(direction) {
    store.commit("breadCrumb/setClassicBreadCrumb", [
        {
            name: this.$t("global.entities.home"),
            link:
                direction === "résidences"
                    ? "/residences"
                    : "/v1/data/accueil/accueil",
        },
    ])
}

async function initDataAndRedirectionHomePage(authResponse) {
    if (authResponse.data.define["ACCUEIL"] === "0") {
        store.commit("account/setAccueil", 0)
        initHomeToBreadCrumb.call(this, "résidences")

        if (this.checkRight("G_RESIDENCES")) {
            this.$router.push({
                name: "Residences",
            })
        } else if (
            this.checkRight("G_TABL_GERE") ||
            this.checkRight("G_TABL_VISU")
        ) {
            this.$router.push({
                name: "V1BulletinBoard",
            })
        } else {
            this.$router.push({
                name: "V1",
                params: {
                    arg1: "data",
                    arg2: "accueil",
                    arg3: "accueil",
                },
            })
        }
        if (localStorage.getItem("lastDateNotification")) {
            store.commit(
                "account/setLastDateNotification",
                localStorage.getItem("lastDateNotification"),
            )
        }
    } else {
        store.commit("account/setAccueil", 1)
        initHomeToBreadCrumb.call(this, "menu")
        this.$router.push({
            name: "V1",
            params: {
                arg1: "data",
                arg2: "accueil",
                arg3: "accueil",
            },
        })
    }
}

export default mixins
